<template>
    <div class="ai-recognize">
        <div class="bg">
            <div class="loading-body">
                <div :class="['loading', loading ? 'active' : '']"></div>
            </div>
            <div class="text" v-if="!loading">
                <el-upload ref="audioUpload" action drag :accept="accept" :http-request="uploadFileHandle"
                    :show-file-list="false" :before-upload="beforeUploadHandle">
                    <el-button icon="el-icon-upload2" type="primary">点击上传音频</el-button>
                </el-upload>
                <p>
                    拖动音频到此处，或者点击此处选择音频。
                    <br />
                    要求wav文件，立体声至少44.1 kHz采样率和16bit
                </p>
            </div>
            <div class="loading-text">
                {{ loading ? '上传中...' : 'AI将为你提供智能助手服务' }}
            </div>
        </div>
    </div>
</template>

<script>
import { uploadMusic } from '@/api/file';
import { aiAudioParse, aiAudioStop } from '@/api/album';
import { audioKeyMap, audioBeforeUploadHandle } from '@/utils/audio';
export default {
    data() {
        return {
            maxSize: 300,
            accept: 'audio/wav',
            loading: false,
            parseCancel: false, // 取消歌词/表演语言
            genreCancel: false, // 取消曲风
            audio: {}, // 音频数据
            aiJosn: {}, // ai 数据更新
            stopLoading: false
        };
    },
    created() { },
    methods: {
        /**
         * 轮询获取AI数据
         * @param {*} url 音频地址
         * @param {*} type 数据类型，1：歌词，2：曲风
         * @param {*} statusKey 状态字段名称
         * @param {*} resultKey 结果字段名称
         * @param {*} errorMsg 异常提示消息
         */
        async pollAiData(url, type, statusKey, resultKey, errorMsg) {
            try {
                if (this[`${type == 1 ? 'parse' : 'genre'}Cancel`]) {
                    const cancelData = {};
                    cancelData[statusKey] = 2;
                    return this.mergeAiData(resultKey, cancelData);
                }
                const response = await aiAudioParse(url, type);
                const { state, result, msg } = response.data;
                if (!state) throw new Error(msg || errorMsg);
                const { [statusKey]: parseStatus } = result;
                // 更新数据
                this.mergeAiData(resultKey, result);
                // 继续轮询
                if (parseStatus == 1) {
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                    await this.pollAiData(url, type, statusKey, resultKey, errorMsg);
                }
            } catch (error) {
                console.error(`AI异常：${error.message}`);
                throw error;
            }
        },
        /**
         * 更新数据
         */
        mergeAiData(resultKey, data) {
            this.aiJosn = { ...this.aiJosn, ...data };
            this.$emit('onSuccess', { audio: this.audio, ...this.aiJosn });
        },
        async uploadFileHandle({ file }) {
            try {
                const formData = new FormData();
                formData.append('file', file);
                this.loading = true;

                const response = await uploadMusic(formData);
                const { state, result, msg } = response.data;

                if (!state) {
                    this.loading = false;
                    return this.$message.error(msg || '音频上传失败，稍后尝试～');
                }
                this.audio = audioKeyMap(result);
                this.pollAiData(result.url, 1, 'parseStatus', 'result', 'AI识别歌词异常，稍后尝试～');
                this.pollAiData(result.url, 2, 'genreStatus', 'result', 'AI识别曲风异常，稍后尝试～');
            } catch (error) {
                this.loading = false;
                console.error(`AI异常：${error.message}`);
            }
        },
        beforeUploadHandle(file) {
            return audioBeforeUploadHandle(file, this);
        },
        async updateStatus(type) {
            if (this.stopLoading) return;
            this.stopLoading = true;
            const response = await aiAudioStop(this.aiJosn.taskId, type == 'parse' ? 1 : 2);
            const { state, msg } = response.data;
            this.stopLoading = false;
            if (!state) return this.$message.error(msg || '停止失败，稍后尝试');
            this[`${type}Cancel`] = true;
            this.mergeAiData(null, { [`${type}Status`]: 2 });
        },
    },
};
</script>
<style lang="scss">
@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.ai-recognize {
    .el-upload-dragger {
        background: transparent !important;
        border: none;
        height: 120px;

        .el-button {
            position: absolute;
            left: 0px;
            top: 28%;
        }
    }

    &.hide {
        display: none;
    }

    .bg {
        background: url('~@/assets/img/ai/bg.png') no-repeat center;
        background-size: cover;
        width: 100%;
        height: 360px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 80px 0;
        position: relative;

        .loading-body {
            width: 360px;
            height: 360px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            position: absolute;
        }

        .loading {
            background: url('~@/assets/img/ai/loading.png') no-repeat center;
            background-size: cover;
            display: block;
            width: 100%;
            height: 100%;

            &.active {
                animation: spin 3s linear infinite;
            }
        }

        .text {
            margin-right: 60px;

            .el-button {
                margin-bottom: 50px;
            }

            p {
                line-height: 34px;
            }
        }

        .loading-text {
            background: url('~@/assets/img/ai/loading-text.png') no-repeat center;
            background-size: contain;
            width: 500px;
            height: 200px;
            padding-top: 106px;
            text-align: center;
        }
    }
}
</style>
